// https://github.com/atomiks/tippyjs/issues/745#issuecomment-607531942

import tippy from 'tippy.js'

let tippyInstances = []

const globalPlugin = {
    fn () {
        const $pageViewer = document.querySelector('.page-viewer')
        return {
            onCreate (instance) {
                if ($pageViewer?.contains(instance.reference)) {
                    setPageViewerTippyProps(instance, $pageViewer)
                }
                tippyInstances = tippyInstances.concat(instance)
            },
            onDestroy (instance) {
                tippyInstances = tippyInstances.filter(i => i !== instance)
            }
        }
    }
}

// Since the config page loads the viewer, tippys inside the viewer can
// leak onto the config page. To present a consistent UI no matter the page,
// prevent this leak.
function setPageViewerTippyProps (instance, boundary) {
    instance.setProps({
        maxWidth: boundary.offsetWidth - 20,
        popperOptions: {
            modifiers: [
                {
                    name: 'preventOverflow',
                    options: {
                        boundary,
                    },
                },
            ],
        }
    })
}

tippy.setDefaultProps({
    plugins: [globalPlugin]
})

export function updateAll (props) {
    tippyInstances.forEach(instance => {
        instance.setProps(props)
    })
}

// TODO: Use these constants?
export const TIPPY_CONTENT_ATTR = 'data-tippy-content'
export const TIPPY_CONTENT_ATTR_SELECTOR = `[${TIPPY_CONTENT_ATTR}]`

export { createSingleton } from 'tippy.js'

export default tippy
